// آدرس مرکزی بک‌اند؛ فقط همینجا تعریف می‌شه و همه‌جای دیگه از اینجا import می‌شه
export const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';